import {
  ApiPath,
  jenisKomponenHonorSchema,
  type CreateJenisKomponenHonorRequest,
  type UpdateJenisKomponenHonorRequest,
} from '@app/shared';
import { apiGet, apiPost, apiPatch, apiDelete, apiList } from '../../lib/api';

export async function getJenisKomponenHonorList(params?: {
  page?: number;
  limit?: number;
  search?: string;
  status_aktif?: boolean;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
}) {
  return apiList(ApiPath.SYSTEM.JENIS_KOMPONEN_HONOR, jenisKomponenHonorSchema, params);
}

export async function getJenisKomponenHonor(id: number) {
  return apiGet(`${ApiPath.SYSTEM.JENIS_KOMPONEN_HONOR}/${id}`, jenisKomponenHonorSchema);
}

export async function createJenisKomponenHonor(body: CreateJenisKomponenHonorRequest) {
  return apiPost(ApiPath.SYSTEM.JENIS_KOMPONEN_HONOR, body, jenisKomponenHonorSchema);
}

export async function updateJenisKomponenHonor(id: number, body: UpdateJenisKomponenHonorRequest) {
  return apiPatch(`${ApiPath.SYSTEM.JENIS_KOMPONEN_HONOR}/${id}`, body, jenisKomponenHonorSchema);
}

export async function deleteJenisKomponenHonor(id: number) {
  return apiDelete(`${ApiPath.SYSTEM.JENIS_KOMPONEN_HONOR}/${id}`);
}
